import styled from 'styled-components';

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 35px;
  background: #f3f4f8;
  border-radius: 30px;
  width: 750px;
  height: 560px;
  overflow-y: hidden;
`;

export const AllContent = styled.div`
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 20px;
  padding: 20px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const MainContent = styled.div`
  display: flex;
  width: 100%;
`;

export const ModuleContainer = styled.div`
  width: 70%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  grid-auto-rows: minmax(40px, auto);
`;

export const ModuleItem = styled.div`
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #222247;
`;

export const CheckboxHeading = styled.span`
  margin-top: 7px;
`;

export const ModuleItemLabel = styled.div`
  grid-column: span 3;
  font-size: 18px;
  font-weight: bold;
  color: #222247;
  margin-bottom: 10px;
`;

export const StatusContainer = styled.div`
  width: 30%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-left: 20px;
  select {
    min-midth: 100%;
  }
`;

export const CloseIconContainer = styled.div`
  position: absolute;
  top: 44px;
  right: 40px;
  cursor: pointer;
  font-size: 21px;
  color: rgb(73, 72, 172);
`;

export const Status1Label = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: #222247;
  margin-top: 14%;
`;

export const CloseIcon = styled.span`
  position: absolute;
  top: 10px;
  right: 20px;
  font-size: 24px;
  font-weight: bold;
  cursor: pointer;
  color: #4948ac;

  &:hover {
    color: red;
  }
`;

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  button {
    border: 1px solid #4948ac;
    border-radius: 4px;
    margin-left: 10px;
  }
`;

export const StatusLabel = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: #222247;
  margin-bottom: 10px;
`;

export const CustomCheckBox = styled.input.attrs({ type: 'checkbox' })`
  margin-right: 10px;
`;

export const FormRow = styled.div`
  margin-bottom: 5px;
  margin-top: 10px;
`;
export const FormRowHeading = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: #222247;
  margin: 10px 0px;
`;

export const CompanyGrid = styled.div`
  display: grid;
  font-size: 16px;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(5, 1fr);
  gap: 10px 52px;
`;

export const CheckBoxContainer = styled.div`
  display: flex;
`;
